       import React from 'react';
import IntlMessages from 'util/IntlMessages';
import ProjectIssueDetailTable from './projectIssueDetailTable';
import ProjectIssueDependency from './projectIssueDependency';
import { getIssueDisplayData } from 'services/projectIssueService';
import { mapIssuesInwardDependenciesToDisplayData, mapIssuesOutwardDependenciesToDisplayData } from 'services/projectIssueService';
// import { TIGHT_FIT_PARAM } from 'constants/System';

const ProjectIssueDetail = ({ projectIssueList, selectedProjectIssue, width, setProjectIssue }) => {
    // const defaultWidth = width > TIGHT_FIT_PARAM ? 150 : 80;

    const mainIcon = (issueType) => {
        if (issueType && issueType.toLowerCase() === 'epic') {
            return 'dashboard';
        }
        if (issueType && issueType.toLowerCase() === 'story') {
            return 'compact';
        }
        if (issueType && issueType.toLowerCase() === 'task') {
            return 'module';
        }
        if (issueType && issueType.toLowerCase() === 'sub-task') {
            return 'comfy';
        }
        return 'stream';
    };

    if (selectedProjectIssue) {
        // const fields = { ...selectedProjectIssue?.fields };
        const displayData = getIssueDisplayData(selectedProjectIssue);
        const inwardDependencies = mapIssuesInwardDependenciesToDisplayData(projectIssueList, selectedProjectIssue) || null;
        const outwardDependencies = mapIssuesOutwardDependenciesToDisplayData(projectIssueList, selectedProjectIssue) || null;
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-6 col-12">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">{displayData?.summary}</h3>
                                    <p className="sub-heading">{displayData?.description}</p>
                                </div>
                            </div>
                            <div className="jr-card-body">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="temp-section mb-4 mb-sm-0 text-center text-sm-left">
                                            <p>
                                                {/* <div className={`btn btn-sm text-uppercase btn-rounded ${style}`}>{order} Order</div> */}
                                                <i className={`detail-icon text-blue-grey zmdi zmdi-view-${mainIcon(displayData?.issuetype)} zmdi-hc-fw`} />
                                            </p>
                                            {displayData?.issuetype ?
                                                <h2 className="temp-point">{displayData?.issuetype}</h2>
                                                : null
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-9 text-center text-sm-left">
                                        <ProjectIssueDetailTable displayData={displayData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <ProjectIssueDependency dependencies={inwardDependencies} title={<IntlMessages id="projectIssue.inwardDependencies" />} />
                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                            <ProjectIssueDependency dependencies={outwardDependencies} title={<IntlMessages id="projectIssue.outwardDependencies" />} />
                        </div>
                    </div>

                </div>
            </div>
        );
    } else {
        return (
            <div className="dashboard animated slideInUpTiny animation-duration-3">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="jr-card jr-card-full-height">
                            <div className="jr-card-header d-flex">
                                <div className="mr-auto">
                                    <h3 className="card-heading">Please select an issue to display details</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default ProjectIssueDetail;


// WEBPACK FOOTER //
// ./components/Agile/projectIssue/projectIssueDetail/index.js